/* AWOL · CROMO
   Un solo comportamiento: sobre el video flota en negativo y se asienta en
   campo blanco al primer scroll. */
class AwolHeader extends HTMLElement {
  connectedCallback() {
    if (!this.classList.contains('awol-header--sobre-media')) return;

    this.alScroll = () => {
      if (window.scrollY > 8) {
        this.setAttribute('data-asentado', '');
      } else {
        this.removeAttribute('data-asentado');
      }
    };

    this.alScroll();
    window.addEventListener('scroll', this.alScroll, { passive: true });
  }

  disconnectedCallback() {
    if (this.alScroll) window.removeEventListener('scroll', this.alScroll);
  }
}

if (!customElements.get('awol-header')) {
  customElements.define('awol-header', AwolHeader);
}
